import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ApiError } from "./lib/api";
import { StudioProvider } from "./lib/context";
import { App } from "./App";
import "./styles.css";
import { registerSW } from "virtual:pwa-register";

// Application installable : la coque est mise en cache ; une nouvelle version s'applique au prochain chargement.
registerSW({ immediate: true });

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      // On ne réessaie pas une erreur métier (4xx) ; seulement le réseau et les 5xx.
      retry: (n, e) => n < 2 && (!(e instanceof ApiError) || e.status === 0 || e.status >= 500),
      refetchOnWindowFocus: false,
    },
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <StudioProvider>
          <App />
        </StudioProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
